import { z } from "zod";
import { RequestTypeWithTagsDtoSchema } from "./RequestTypeWithTagsDto";
import { RequestTagDataSchema } from "./RequestTagData";

export const GetRequestTypesWithTagsOutputSchema = z.object({
    requestTypeAndTags: z.array(RequestTypeWithTagsDtoSchema),
    parentTags: z.array(RequestTagDataSchema).nullish(),
});

export type GetRequestTypesWithTagsOutput = z.infer<typeof GetRequestTypesWithTagsOutputSchema>;